export const BASE_URL = "https://camp-coding.site/elsedawy/api/";
